import React, { useEffect, useState } from 'react';
import { Card, ExpandingText, IconButton } from '@totalsoft/rocket-ui';
import PropTypes from 'prop-types';
import XMLViewer from 'react-xml-viewer';
import { useTranslation } from 'react-i18next';
import { Assignment } from '@mui/icons-material';
import { copyToClipboard } from 'utils/functions';

const EvaluationLogXMLViewerWrapper = ({ tabValue, data }) => {
  const { t } = useTranslation();
  const [xml, setXml] = useState('');
  useEffect(() => {
    if (tabValue === 0) {
      setXml(data.inputData);
      return;
    }
    if (tabValue === 1) {
      setXml(data.processData);
      return;
    }
    if (tabValue === 2) {
      setXml(data.executionData);
      return;
    }
  }, [data.executionData, data.inputData, data.processData, tabValue]);
  if (!xml)
    return (
      <Card>
        <ExpandingText text={t('EvaluationLogs.XmlException')} />
      </Card>
    );

  return (
    <Card>
      <XMLViewer xml={xml} />
      <IconButton
        id={`EvaluationLogs_Copy`}
        size='small'
        variant='text'
        onClick={copyToClipboard(xml)}
        color='primary'
        tooltip={t('General.CopyToClipboard')}
      >
        <Assignment fontSize={'inherit'} />
      </IconButton>
    </Card>
  );
};

EvaluationLogXMLViewerWrapper.propTypes = {
  data: PropTypes.object.isRequired,
  tabValue: PropTypes.number.isRequired
};

export default EvaluationLogXMLViewerWrapper;
